import { AppTheme } from '@/store/modules/app';
import { getTheme, removeAfterLoginRedirectUrl } from './localstorage';
import { BookingModule } from '@/store/modules/booking';
import { ReportModule } from '@/store/modules/report';
import { TicketSettingModule } from '@/store/modules/ticketsetting';

export const getInitialTheme: () => AppTheme = () => {
  const savedTheme = getTheme();
  if (savedTheme && Object.values(AppTheme).includes(savedTheme as AppTheme)) {
    return savedTheme as AppTheme;
  }

  return AppTheme.Light;
};

export const clearUserRelatedStates = () => {
  BookingModule.ClearBookingStore();
  ReportModule.ClearReportStore();
  TicketSettingModule.ClearTicketSettingStore();
  removeAfterLoginRedirectUrl();
};
